<template>
  <div id="app">
    <router-view />
    <lockscreen v-if="!!showLockScreen" />
  </div>
</template>
<script setup lang="ts">
import Lockscreen from './views/lockscreen.vue';
const { showLockScreen } = storeToRefs(useAppStore());
// const layout = computed(() => route.meta?.layout || 'default');
</script>
